import { render, staticRenderFns } from "./Establishment.vue?vue&type=template&id=356b1482"
import script from "./Establishment.vue?vue&type=script&lang=js"
export * from "./Establishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports